import { ArticleMeta } from 'types/blog';

// ==============================|| 記事のメタ ||============================== //
//
// 一覧・カテゴリ一覧・関連記事のカードは、このファイルだけを読む。
// 本文(同名の .ts)と分けているのは、一覧を描くのに全記事の本文まで
// JSバンドルへ入れないため(詳しくは src/const/blog/registry.ts)。
//
// ★ ここに本文を書かないこと。書いた瞬間、一覧がそれを読み込むようになる。

export const meta: ArticleMeta = {
    slug: 'kobetsu-shien-keikaku-kakikata',
    title: '【記入例あり】個別支援計画の書き方｜児発・放デイの5領域と記載例',
    // モバイルの検索結果では冒頭120文字程度しか表示されないため、
    // 狙っているキーワード(個別支援計画の書き方・記入例・5領域)を先頭に寄せている
    description:
        '個別支援計画の書き方を、項目ごとの記入例つきで解説します。児童発達支援・放課後等デイサービスの様式に何を書くか、5領域との関連性をどう示すか、ありがちなNG表現の直し方、運営指導で指摘されやすい点まで。国が示す記載例の画像と、条文の出典を添えてまとめました。',
    excerpt:
        '様式は埋まったけれど、この書き方で本当に良いのか。項目ごとの記入例と5領域の盛り込み方、NG表現の直し方までをまとめました。',
    category: '個別支援計画',
    keywords: [
        '個別支援計画 書き方',
        '個別支援計画 記入例',
        '個別支援計画 5領域',
        '児童発達支援 個別支援計画',
        '放課後等デイサービス 個別支援計画',
        '個別支援計画 長期目標 短期目標'
    ],
    publishedAt: '2026-09-14',
    updatedAt: '2026-09-16',
};
